// 获取所在位置及生成dom
export const getErrorTextPosition = (options) => {
  let { fatherContent, positionDom, errorItem, modelItemType, moduleId, wrap } = options
  // 提示元素
  let tipsDom = document.createElement('div');

  let positionHeight = positionDom.offsetHeight;
  // console.log(positionHeight, positionHeight>24 ? '计算错误，超出了' : '计算正常')
  // 先计算高度是否超出，节省性能
  if(positionHeight>24){
    return {
      beyond: true,
      position:{
        height: positionHeight
      }
    }
  }else{
    // 父级相对位置
    let fatherLeft = getOffsetRelative(fatherContent).left;
    let fatherTop = getOffsetRelative(fatherContent).top;
    // 计算位置的元素相对位置
    let positionLeft = getOffsetRelative(positionDom).left;
    let positionTop = getOffsetRelative(positionDom).top;

    let positionWidth = positionDom.offsetWidth;
    let position = {
      left: positionLeft - fatherLeft,
      top: positionTop - fatherTop,
      width: positionWidth,
      height: positionHeight,
    }

    // 给提示dom设置样式
    // console.log(errorItem)
    tipsDom.classList.add('highlightContainer', `error_type_color_${errorItem.error_type}`)
    // tipsDom.style.width = `${position.width}px`;
    tipsDom.style.height = `${position.height}px`;
    tipsDom.style.left = `${position.left}px`;
    tipsDom.style.top = `${position.top}px`;
    // 添加唯一标识
    tipsDom.setAttribute('data-uuid', errorItem.uuid)
    // 标记元素换行
    if(wrap){
      tipsDom.setAttribute('data-wrap', 'true')
    }
    return {
      beyond: false, //是否超出高度
      tipsDom,
      position
    }
  }
}

// 获取元素的绝对位置坐标（对于页面左上角）
export const getOffsetRelative = (element) =>{
  //计算x坐标
  var actualLeft = element.offsetLeft;
  var current = element.offsetParent;
  while (current !== null){
    actualLeft += current.offsetLeft;
    current = current.offsetParent;
  }
  //计算y坐标
  var actualTop = element.offsetTop;
  var current = element.offsetParent;
  while (current !== null){
    actualTop += (current.offsetTop+current.clientTop);
    current = current.offsetParent;
  }
  //返回结果
  return {left: actualLeft, top: actualTop}
}

// 整理替换之后的html
export const getErrorCorrectHtml = (correct_word, matchItem) => {
  let correctHteml = '';
  let excludeKeys = ['0', 'findIndex', 'groups', 'index', 'input']
  let htmlKey = Object.keys(matchItem).filter(key => !excludeKeys.includes(key) );
  // console.log('有数据的htmlKey', htmlKey)
  htmlKey.forEach(key=>{
    correctHteml += matchItem[key] || ''
  })
  correctHteml += correct_word
  return correctHteml
}

// 获取匹配文字的正则
export const getErrorTextRegExp = (wrong_word) => {
  // 拼接正则
  let regExp = ''
  wrong_word.split('').forEach((word,wordIndex)=>{
    let newWord = checkWordRegExp(word);
    if(wordIndex < wrong_word.length -1){
      regExp += `${newWord}(<.*?>)?`
    }else{
      regExp += `${newWord}`
    }
  })
  return regExp
}

// 判断当前字符是否是特殊符号
export const checkWordRegExp = (word) => {
  let special = "| ^$+?=!.()\/()[]{}";
  if(!word){
    return word
  }
  if(special.includes(word)){
    return '\\'+`${word}`
  }else{
    return word
  }
}

// 提取文字内容
export const getHtmlText = (html) => {
  return html.replace(/<.*?>/g, '')
}
// 检测文字是否存在
export const hasErrorText = (originText, errorText, errorIndex) => {
  let hasError = []
  // console.log(originText, errorText, errorIndex)
  try {
    hasError = Array.from( originText.matchAll(RegExp( getErrorTextRegExp(errorText) ,'g')) ).filter(item=>{
      // console.log(item, errorIndex)
      return item.index === errorIndex
    })
  } catch (error) {
    console.log('检测报错', error)
  }
  return !!hasError.length
}